import React from 'react'
import { Text, IconMapPin, Button, csx, dataAttr } from '@vtex/admin-ui'
import trim from 'lodash/trim'
import { FormattedMessage, injectIntl } from 'react-intl'
import { WithRouterProps } from 'react-router'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import { BRAZIL_COUNTRY_CODE } from '@/checkout-instore-legacy/customer/constants'
import { maskPostalCode } from '@/checkout-instore-legacy/shipping/utils'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

type AddressBarProps = {
  simulationAddress: Address
  countryCode: string
}

const AddressBar = withRouter(
  ({
    router,
    simulationAddress,
    countryCode,
  }: // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  AddressBarProps & WithRouterProps) => {
    const {
      postalCode,
      number,
      street,
      neighborhood,
      city,
      state,
    } = simulationAddress

    const isBrazilian = countryCode === BRAZIL_COUNTRY_CODE
    const maskedPostalCode = isBrazilian
      ? maskPostalCode(postalCode, BRAZIL_COUNTRY_CODE)
      : postalCode

    const formattedNumber =
      number == null || trim(number) === '' ? '' : `, ${number}`
    const formattedStreet = street ? `${street}${formattedNumber}` : ''
    const formattedNeighborhood = neighborhood ? `${neighborhood} · ` : ''

    return (
      <div
        className={csx({
          display: 'flex',
          flexWrap: 'wrap',
        })}
      >
        <div
          className={csx({
            width: '5%',
            flexDirection: 'column',
            paddingTop: '1.25rem',
          })}
        >
          <IconMapPin />
        </div>
        <div
          className={csx({
            width: '70%',
            flexDirection: 'column',
            marginLeft: '10px',
          })}
        >
          <div
            className={csx({
              '> *': {
                display: 'block',
              },
            })}
            data-testid="address-bar-product-page"
          >
            <Text
              className={csx({
                fontSize: 14,
                fontWeight: 600,
                display: 'block',
              })}
            >
              {maskedPostalCode}
            </Text>
            <Text className={csx({ dislay: 'block', whiteSpace: 'pre' })}>
              {formattedStreet}
            </Text>
            <Text className={csx({ dislay: 'block', whiteSpace: 'pre' })}>
              {formattedNeighborhood}
              {city} - {state}
            </Text>
          </div>
        </div>
        <div
          className={csx({
            width: '20%',
            flexDirection: 'column',
            paddingTop: '.75rem',
          })}
        >
          <Button
            className={csx({
              width: '87px',
              height: '32px',
              right: '20%',
            })}
            variant="secondary"
            onClick={() => router.push('#/change-address-drawer')}
            data-testid="cep-change-button"
          >
            <Text
              variant="action1"
              className={csx({
                fontSize: '12px',
                lineHeight: '16px',
                alignItems: 'center',
                textAlign: 'center',
                [dataAttr('variant', 'action1')]: {
                  color: '#134CD8 !important',
                },
              })}
            >
              <FormattedMessage id="changeZipCodeLabel" />
            </Text>
          </Button>
        </div>
      </div>
    )
  }
)

export default withMediaQuery(injectIntl(AddressBar))
